// extracted by mini-css-extract-plugin
module.exports = {"sagaContainer":"Saga_sagaContainer__1SQlE"};